import { BASE_URL } from './config';
import { authFetch } from '../utils/authFetch';

export async function uploadImagesMultipart(files) {


  const propertyId = localStorage.getItem("propertyId");
  console.log("Uploading images for propertyId:", propertyId);
  console.log("Files to upload:", files);

  if (!propertyId || !files || files.length === 0 || files.length > 6) {
    throw new Error("Please provide a valid propertyId and between 1 to 6 image files.");
  }

  const formData = new FormData();
  formData.append("propertyId", propertyId);

  files.forEach((file) => {
    formData.append("files", file);
  });


  try {
    const response = await authFetch(`${BASE_URL}/media/generate-upload-url`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();



    console.log("Upload successful:", data);
    return {
      message: 'Files uploaded successfully',
      uploadedFiles: data.uploadedFiles || [],
    };

  } catch (error) {
    console.error("Upload error:", error);
    throw error;
  }
}


export async function uploadFiles(files) {
  const uploadedFiles = [];

  for (const file of files) {
    const res = await authFetch(`${BASE_URL}/media/generate-upload-url`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({

        filename: file.name,
        contentType: file.type,
      }),

    });

    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(`Failed to get upload URL: ${errorText}`);
    }

    const { uploadUrl, fileUrl } = await res.json();

    const uploadRes = await fetch(uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file,
    });

    if (!uploadRes.ok) {
      throw new Error(`Failed to upload ${file.name}`);
    }

    uploadedFiles.push({ fileName: file.name, url: fileUrl });
  }

  return {
    message: 'Files uploaded successfully',
    uploadedFiles,
  };
}
